import { instanceToPlain, plainToInstance } from 'class-transformer';
import { useNavigate, useParams } from 'react-router-dom';
import FormStepper from 'components/form-stepper/FormStepper';
import { useEdit } from 'hooks/useEdit';
import { ActionCloseReason } from 'constants/CloseReasonTypes';
import { TypeMode } from 'constants/TypeMode';
import StandardForm from 'components/shared/StandardForm';

// eslint-disable-next-line react/prop-types, no-unused-vars
const EditDataStandardForm = ({
    navigateTo,
    slice,
    service,
    pageTitle,
    config,
    entity,
}) => {
    const navigate = useNavigate();
    let { id } = useParams();

    const [, status, defaultValue] = useEdit(
        // eslint-disable-next-line react/prop-types
        async () => service.getEntity(id),
        true,
        plainToInstance(entity, {}, { exposeDefaultValues: true }),
    );

    const handleOnClose = action => {
        navigate(navigateTo, {
            state: action === ActionCloseReason.Submit ? 'refresh' : null,
        });
    };

    const handleOnSubmit = async (data, successCallback, errorCallback) => {
        try {
            // eslint-disable-next-line react/prop-types
            // delete data.id;
            const response = await service.update(instanceToPlain(data));
            successCallback('Data saved');
        } catch (err) {
            errorCallback(err, 'An error occurred');
        }
    };

    return (
        <StandardForm
            title={pageTitle}
            mode={TypeMode.Edit}
            formConfig={config}
            defaultErrors={defaultValue?.errors}
            defaultValue={instanceToPlain(defaultValue)}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            originalMessage={defaultValue?.originalMessage}
            slice={slice}
        >
            {({ formConfig, methods, defaultValue, mode, activeStep }) => (
                <FormStepper
                    forms={formConfig}
                    mode={mode}
                    methods={methods}
                    defaultValue={defaultValue}
                    activeStep={activeStep}
                />
            )}
        </StandardForm>
    );
};

export default EditDataStandardForm;
